import {
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonInput,
  IonPage,
  IonRow,
  IonSpinner,
  useIonToast,
} from "@ionic/react";
import { RouteComponentProps, useLocation } from "react-router";
import { useState } from "react";
import { TextFieldTypes } from "@ionic/core";
import "./ResetPassword.css";
import "./Login.scss";
import { APIService } from "../network/APIService";

type PasswordInput = {
  password: string;
  inputType: TextFieldTypes;
};

const ResetPassword: React.FC<RouteComponentProps> = ({ history }) => {
  const { search } = useLocation();
  const userToken = new URLSearchParams(search).get("token")!;

  const [presentToast] = useIonToast();

  const [sendingPasswordResetRequest, setSendingPasswordResetRequest] = useState(false);
  const [passwordOne, setPasswordOne] = useState<PasswordInput>({ password: "", inputType: "password" });
  const [passwordTwo, setPasswordTwo] = useState<PasswordInput>({ password: "", inputType: "password" });

  const passwordsAreValid = validatePassword();

  function onPasswordOneChange(pass: string) {
    setPasswordOne(prev => ({ ...prev, password: pass }));

    validatePassword();
  }

  function onPasswordTwoChange(pass: string) {
    setPasswordTwo(prev => ({ ...prev, password: pass }));

    validatePassword();
  }

  function validatePassword() {
    if (passwordOne.password !== passwordTwo.password) {
      return false;
    }

    const valid = passwordOne.password.match(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$£!%*?&])[A-Za-z\d@$£!%*?&]{12,}$/g
    );
    return !valid ? false : true;
  }

  async function handleReset() {
    setSendingPasswordResetRequest(true);
    const success = await APIService.updatePassword(userToken, passwordOne.password);
    if (success) {
      presentToast({
        message: "Password updated successfully",
        // mode: "ios",
        duration: 3000,
      });
    } else {
      presentToast({
        message: "Password failed to reset. Your link may no longer be valid.",
        // mode: "ios",
        duration: 3000,
      });
    }
    setSendingPasswordResetRequest(false);
  }

  return (
    <IonPage>
      <IonContent>
        <IonGrid id="loginGrid">
          <IonRow id="loginRow">
            <IonCol
              id="loginMainContainer"
              size="12"
              size-md="6"
              offset-md="3"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                paddingLeft: "16px",
                paddingRight: "16px",
              }}
            >
              <h1 className="pageHeader" style={{}}>
                Reset Password
              </h1>
              <div id="passwordContraintsContainer">
                <p>Password must:</p>
                <div>
                  <li>Be at least 12 characters long</li>
                  <li>Include at least one of the following</li>
                  <ul>
                    <li>An uppercase letter</li>
                    <li>A lowercase letter</li>
                    <li>A special character</li>
                    <li>A number</li>
                  </ul>
                </div>
              </div>
              <p className="loginInputLabel">Create your new password</p>
              <div className="passwordInputContainer">
                <IonInput
                  value={passwordOne.password}
                  onIonChange={e => onPasswordOneChange(e.detail.value!)}
                  type={passwordOne.inputType}
                />
                <IonButton
                  style={{ width: "60px" }}
                  onClick={() =>
                    setPasswordOne(prev => ({ ...prev, inputType: prev.inputType === "text" ? "password" : "text" }))
                  }
                >
                  {passwordOne.inputType === "password" ? "show" : "hide"}
                </IonButton>
              </div>
              <p style={{ marginTop: "12px" }} className="loginInputLabel">
                Confirm your new password
              </p>
              <div className="passwordInputContainer">
                <IonInput
                  value={passwordTwo.password}
                  onIonChange={e => onPasswordTwoChange(e.detail.value!)}
                  type={passwordTwo.inputType}
                />
                <IonButton
                  style={{ width: "60px" }}
                  onClick={() =>
                    setPasswordTwo(prev => ({ ...prev, inputType: prev.inputType === "text" ? "password" : "text" }))
                  }
                >
                  {passwordTwo.inputType === "password" ? "show" : "hide"}
                </IonButton>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: "24px" }}>
                <IonButton
                  disabled={!passwordsAreValid || sendingPasswordResetRequest}
                  className="yellowBtn"
                  onClick={handleReset}
                >
                  {sendingPasswordResetRequest ? (
                    <IonSpinner className="resetPassSpinner" />
                  ) : (
                    <span>Reset Password</span>
                  )}
                </IonButton>
                <IonButton style={{ color: "#7a7056" }} className="textOnlyBtn" routerLink="/login">
                  Go to Login
                </IonButton>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default ResetPassword;
